module.exports = __webpack_public_path__ + "images/backgrounds/canyon/full.74fb5c2667c01f60eb5f.jpg";